import Vue from "vue"
import Vuelidate from "vuelidate"
import VueLodash from "vue-lodash"
//import store from "./store/store"
import App from "./App.vue"
import router from "./router"
import Toasted from 'vue-toasted'
import vuetify from './plugins/vuetify'
import Notification from "vue-notification"
import VueBrowserUpdate from '@sum.cumo/vue-browserupdate'
//const pass = 'cb2w1234'
const options = { name: "_." }
Vue.use(VueLodash, options)
Vue.use(Vuelidate)
Vue.use(Toasted)
Vue.use(Notification)
Vue.use(VueBrowserUpdate, {
  options: {
    text: {
      'msg': 'Votre navigateur Web ({brow_name}) est obsolète.',
      'msgmore': 'Mettez à jour votre navigateur pour plus de sécurité, de vitesse et la meilleure expérience sur ce site.',
      'bupdate': 'Mettez à jour votre navigateur',
      'bignore': 'Ignorez'
    }
  }
})
//https://www.npmjs.com/package/vue-phone-number-input
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
Vue.component('vue-phone-number-input', VuePhoneNumberInput);

//Vue.config.productionTip = true
//Vue.config.silent = true  // ecrit les logs
//Vue.config.performance = true // active le module perf
//Vue.config.devtools = false // desactive le devtools des navigateurs

//dev
Vue.config.productionTip = false
Vue.config.silent = false  // ecrit les logs
Vue.config.performance = false // active le module perf
Vue.config.devtools = true // desactive le devtools des navigateurs
const INVISIBLE_CARACTERE ="ㅤ";
Vue.directive('number-only', {
  bind(el, binding, vnode) {
    el.addEventListener('input', function(event) {
      const originalValue = event.target.value;
      let trimmedValue = originalValue.replace(/[^0-9]/gi,'');
      if(trimmedValue.length > 9){
        trimmedValue= trimmedValue.substring(0,9);
      }
      event.target.value = trimmedValue;
      vnode.componentInstance.$emit('input', trimmedValue + INVISIBLE_CARACTERE);
      setTimeout(()=>{
       // event.target.value = trimmedValue;
        vnode.componentInstance.$emit('input', trimmedValue);
      },5)

    });
  }
});
Vue.directive('amount-only', {
  bind(el, binding, vnode) {
    el.addEventListener('input', function(event) {
      const originalValue = event.target.value;
      let trimmedValue = originalValue.replace(/[^0-9]/gi,'');
      trimmedValue= Math.abs(+trimmedValue);
      if(trimmedValue < 1){
        trimmedValue = ''
      }
      event.target.value = trimmedValue + INVISIBLE_CARACTERE;
      //vnode.componentInstance.$emit('input', trimmedValue + INVISIBLE_CARACTERE);
      setTimeout(()=>{
       event.target.value = trimmedValue;
       // vnode.componentInstance.$emit('input', trimmedValue);
      },5)

    });
  }
});
Vue.directive('alpha-only', {
  bind(el, binding, vnode) {
    el.addEventListener('input', function(event) {
      const originalValue = event.target.value;
      let trimmedValue = originalValue.replace(/[0-9]/gi,'');

      event.target.value = trimmedValue;
      vnode.componentInstance.$emit('input', trimmedValue + INVISIBLE_CARACTERE);
      setTimeout(()=>{
       // event.target.value = trimmedValue;
        vnode.componentInstance.$emit('input', trimmedValue);
      },5)

    });
  }
});

//router.beforeEach((to, from, next) => {
//let isLogged = false
//if(to.matched.some(record => record.meta.requiresAuth)){
//   if(localStorage.getItem('isLogged') === null || localStorage.getItem('isLogged') === 'false'){
//     while (!isLogged) {
//         let passwd = prompt('Veuillez saisir le mot de passe: ')
//         if(passwd !== null && passwd == pass){
//             localStorage.setItem('isLogged', true)
//             isLogged = true
//             next({
//               name: 'home'
//             })
//         }
//     }
// }else{
//   next()
// }
//}
//}) 
new Vue({
  //store,
  router,
  vuetify,
  render: h => h(App)
}).$mount("#app")
